export const SITE = {
  brand: "Crescet EduStreams",
  legalName: "Crescet EduStreams Consulting OPC Private Limited",
  tagline: "One ecosystem. Multiple student needs. Human expertise powered by technology.",
  overview:
    "Crescet EduStreams Consulting OPC Private Limited is an education-focused company building an integrated ecosystem for students across their academic and career journey. The company brings together career guidance, student assessments, higher-education admissions, expert mentoring, and technology-enabled student support through specialised platforms and brands.",
  email: "hello@crescetedustreams.in",
  address: "Crescet EduStreams, Bengaluru, India",
  whatsapp: "https://wa.me/+919148899369", // E.164 without + for wa.me link
  whatsappDisplay: "+91 91488 99369",
  linkedin: "https://www.linkedin.com/company/crescet-edustreams-consulting/posts",
  colors: {
    emerald: "#0B5D4B",
    darkEmerald: "#063B30",
    gold: "#C89B3C",
    softWhite: "#F8FAF9",
  },
};

export const VENTURES = [
  {
    name: "AdmissionsNest",
    label: "Higher Education & Admissions",
    desc: "Supports students with higher-education opportunities in India and abroad, helping them explore institutions, programs, and admission pathways.",
    url: "https://admissionsnest.in",
    live: true,
    image:
      "https://images.unsplash.com/photo-1495995424756-6a5a3f9e7543?auto=format&fit=crop&w=900&q=70",
  },
  {
    name: "CounselNest",
    label: "Career Intelligence & Assessments",
    desc: "Focuses on career intelligence, scientific student assessments, and career counselling to move career guidance beyond generic advice.",
    url: "https://counselnest.in",
    live: true,
    image:
      "https://images.unsplash.com/photo-1637589316488-6d4c41b335cd?auto=format&fit=crop&w=900&q=70",
  },
  {
    name: "TutorsNest",
    label: "Personalised Learning & Mentoring",
    desc: "Connects students with tutors, mentors, and subject-matter experts for personalised academic and learning support.",
    url: "https://tutorsnest.in",
    live: true,
    image:
      "https://images.unsplash.com/photo-1522661067900-ab829854a57f?auto=format&fit=crop&w=900&q=70",
  },
];

export const LEADERSHIP = [
  {
    name: "Founder & CEO",
    role: "Vision & Strategy",
    bio: "Building Crescet Edustreams as a connected ecosystem that simplifies every major decision in a student's journey.",
    image: "/F1.png",
  },
  {
    name: "Co-Founder",
    role: "CounselNest & Assessments",
    bio: "Leads the certified counsellor network, psychometric standards, and outcome tracking across the ecosystem.",
    image: "/F2.png",
  },
  {
    name: "Head of Partnerships",
    role: "Schools, Colleges & Universities",
    bio: "Builds long-term partnerships with institutions, training providers, and assessment partners.",
    image:
      "https://images.unsplash.com/photo-1551731409-43eb3e517a1a?auto=format&fit=crop&w=600&q=70",
  },
];

export const OPEN_ROLES = [
  {
    title: "Career Counsellor",
    location: "Remote / Bengaluru",
    type: "Full-time",
    description:
      "Certified counsellor with 3+ years of experience guiding students across streams, career paths, and overseas decisions. Comfort with psychometric tools is a plus.",
  },
  {
    title: "Education Content Writer",
    location: "Remote",
    type: "Full-time / Contract",
    description:
      "Write deeply researched articles, guides, and resources for students and parents. Strong background in Indian + global education systems required.",
  },
  {
    title: "Partnerships Manager",
    location: "Bengaluru",
    type: "Full-time",
    description:
      "Build and nurture partnerships with schools, colleges, universities, training partners, and assessment providers. Sales + relationship background preferred.",
  },
];

export const WHY_CHOOSE = [
  {
    title: "One Connected Ecosystem",
    category: "Integrated Pathways",
    desc: "Instead of treating assessments, counselling, admissions, and tutoring as separate journeys, Crescet unifies these services so students never have to navigate fragmented silos.",
  },
  {
    title: "Career Intelligence",
    category: "CounselNest",
    desc: "Developing a scientific career intelligence ecosystem combining validated psychometrics, DMIT testing, and certified counsellors to guide students beyond generic advice.",
  },
  {
    title: "Higher Education Pathways",
    category: "AdmissionsNest",
    desc: "Helping students explore higher-education opportunities across India and international destinations, simplifying university discovery, program selection, and admission pathways.",
  },
  {
    title: "Personalised Learning & Tutoring",
    category: "TutorsNest",
    desc: "Connecting students with tutors, mentors, and subject-matter experts for personalised academic mastery, board excellence, and competitive entrance preparation.",
  },
  {
    title: "Technology + Human Expertise",
    category: "AskPurple & Digital Tools",
    desc: "Harnessing technology for scalable discovery and AI assistance via AskPurple, paired with the indispensable guidance of experienced counsellors and educators.",
  },
  {
    title: "Student-Centric Approach",
    category: "Core Philosophy",
    desc: "Starting with the student's unique abilities, interests, and aspirations rather than the product, enabling students and parents to make informed, confident long-term decisions.",
  },
];
